import React, { FC } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import RoleGuard from "./Guards/RoleGuard";
import ProductPage from "./Pages/ProductPage";
import CategoryPage from "./Pages/CategoryPage";
import AuthenticationGuard from "./Guards/AuthenticationGuard";
import LoginGuard from "./Guards/LoginGuard";
import AuthenticationPage from "./Pages/AuthenticationPage";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage";
import Layout from "./Layout";
import Dashboard from "./Pages/Dashboard";
import Logout from "./Pages/Logout";
import StorePage from "./Pages/StorePage";
import ShopsPage from "./Pages/ShopsPage";
import BrandPage from "./Pages/BrandPage";
import UserPage from "./Pages/UserPage";
import StoreDiscountPage from "./Pages/StoreDiscountPage";
import OffersPage from "./Pages/OffersPage";
import NotificationsPage from "./Pages/NotificationsPage";
import ShopDiscountPage from "./Pages/ShopDiscountPage";
import CategoryDiscountPage from "./Pages/CategoryDiscountPage";
import BrandDiscountPage from "./Pages/BrandDiscountPage";
import ProductDiscountPage from "./Pages/ProductDiscountPage";
import InventoryPage from "./Pages/InventoryPage";
import AddressPage from "./Pages/AddressPage";
import ReviewPage from "./Pages/ReviewPage";
import CouponsPage from "./Pages/CouponsPage";
import OrderPage from "./Pages/OrderPage";
import CheckoutPage from "./Pages/CheckoutPage";
import DiscountPage from "./Pages/DiscountPage";
import CustomersPage from "./Pages/CustomersPage";
import LowStockPage from "./Pages/LowStockPage";
import ReportsPage from "./Pages/ReportsPage";
import CashDrawerPage from "./Pages/CashDrawerPage";
import DeliverySlotsPage from "./Pages/DeliverySlotsPage";
import PickupSlotsPage from "./Pages/PickupSlotsPage";
import ProfilePage from "./Pages/ProfilePage";
import SettingsPage from "./Pages/SettingsPage";

const Router: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/checkout"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <CheckoutPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/review"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ReviewPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/coupons"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <CouponsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/order"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <OrderPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          index
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']}>
              <Layout>
                <Dashboard />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/products"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ProductPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/category"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <CategoryPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/stores"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <StorePage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/shops"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ShopsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/brands"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <BrandPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/users"
          element={
            <RoleGuard allowedRoles={['O', 'A']}>
              <Layout>
                <UserPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/address"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']}>
              <Layout>
                <AddressPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/auth"
          element={
            <LoginGuard>
              <AuthenticationPage />
            </LoginGuard>
          }
        ></Route>
        <Route
          path="/forgot-password"
          element={
            <LoginGuard>
              <ForgotPasswordPage />
            </LoginGuard>
          }
        ></Route>
        <Route
          path="/dashboard"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']}>
              <Layout>
                <Dashboard />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/profile"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ProfilePage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/settings"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <SettingsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/logout"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']}>
              <Layout>
                <Logout />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/brand-discount"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <BrandDiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route path="/cart" element={<Navigate to="/checkout" replace />}></Route>
        <Route
          path="/category-discount"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <CategoryDiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/inventory"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <InventoryPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/product-discount"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ProductDiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/shop-discount"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <ShopDiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/store-discount"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <StoreDiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/offers"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <OffersPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/notifications"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <NotificationsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/discounts"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <DiscountPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/customers"
          element={
            <RoleGuard allowedRoles={['O', 'A']}>
              <Layout>
                <CustomersPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/low-stock"
          element={
            <RoleGuard allowedRoles={['O', 'A', 'S']} requireWriteAccess={false}>
              <Layout>
                <LowStockPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/reports"
          element={
            <RoleGuard allowedRoles={['O', 'A']} requireWriteAccess={false}>
              <Layout>
                <ReportsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/cash-drawer"
          element={
            <RoleGuard allowedRoles={['O', 'A']}>
              <Layout>
                <CashDrawerPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/delivery-slots"
          element={
            <RoleGuard allowedRoles={['O', 'A']}>
              <Layout>
                <DeliverySlotsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        <Route
          path="/pickup-slots"
          element={
            <RoleGuard allowedRoles={['O', 'A']}>
              <Layout>
                <PickupSlotsPage />
              </Layout>
            </RoleGuard>
          }
        ></Route>
        {/* Default route - redirect to login if not authenticated */}
        <Route
          path="*"
          element={
            <AuthenticationGuard>
              <Navigate to="/dashboard" replace />
            </AuthenticationGuard>
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
